/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Breadcrumbs, BreadcrumbsProps } from '@mantine/core'
import AnchorLink from '../AnchorLink'

function AdminBreadcrumb (props: BreadcrumbsProps) {
  const { children, ...others } = props
  const Component = children ? AnchorLink : 'span'
  return (
    <Breadcrumbs fz="sm" {...others}>
      <Component to="/admin">
        <FormattedMessage
          id="administration"
          defaultMessage="Administration"
        />
      </Component>
      {children}
    </Breadcrumbs>
  )
}

export default AdminBreadcrumb
